/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Contact_Code_Trees_Create_NameInputs */

const en_forms_contact_code_trees_create_name = /** @type {(inputs: Forms_Contact_Code_Trees_Create_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const de_forms_contact_code_trees_create_name = /** @type {(inputs: Forms_Contact_Code_Trees_Create_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Forms_Contact_Code_Trees_Create_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_contact_code_trees_create_name = /** @type {((inputs?: Forms_Contact_Code_Trees_Create_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Contact_Code_Trees_Create_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_contact_code_trees_create_name(inputs)
	return de_forms_contact_code_trees_create_name(inputs)
});